// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5387":"css/admin-app.7021","6639":"css/app.7021"}[chunkId] + ".css";
};